/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { State } from '../redux';
import { tasksReducer } from './tasksReducer';
import { journalReducer } from './journalReducer';
import { signingRoomReducer } from './signingRoomReducer';
import { layoutReducer } from './layoutReducer';
import { documentReducer } from './documentReducer';
import { roomReducer } from './roomReducer';
import { pageReducer } from './pageReducer';
import { callReducer } from './callReducer';
import { userReducer } from './userReducer';

export const rootReducer = combineReducers<State>({
  form: formReducer,
  tasks: tasksReducer,
  entry: journalReducer,
  signingRoom: signingRoomReducer,
  layout: layoutReducer,
  document: documentReducer,
  roomDetail: roomReducer,
  page: pageReducer,
  callDetails: callReducer,
  user: userReducer,
});
